export default function SvgRewind() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="40px"
      viewBox="0 -960 960 960"
      width="40px"
      fill="white"
    >
      <path d="M794.21-295.38 521.49-480l272.72-184.62v369.24Zm-355.7 0L165.79-480l272.72-184.62v369.24Z" />
    </svg>
  );
}
